const renderValue = (value: any) => {
  // Check if value is an object and not null or an array
  if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
    // Handle the object case, e.g., by rendering its properties
    // Adjust this logic based on how you want to display the object
    return `${JSON.stringify(value)}`;
  }
  // Return the value directly if it's not an object
  return value;
};

export function getValueAtPath(
  object: Object,
  path: string | string[],
  defaultValue?: string
): any {
  const pathArray = Array.isArray(path) ? path : [path];
  let currentObject = object;
  for (let key of pathArray) {
    if (currentObject == null || currentObject[key] === undefined) {
      // If path does not exist return undefined or a safer alternative such as the string 'N/A'
      return defaultValue;
    }
    currentObject = currentObject[key];
  }
  return renderValue(currentObject);
}

//Returns true if succesfull, false otherwise
export function changeValueAtPath(
  object: Object,
  path: string | string[],
  newValue: any
): boolean {
  const pathArray = Array.isArray(path) ? path : [path]; // Ensure path is an array
  let currentObject = object;

  for (let i = 0; i < pathArray.length; i++) {
    const key = pathArray[i];

    // If we're at the last key, set the new value
    if (i === pathArray.length - 1) {
      currentObject[key] = newValue;
      return true;
    }

    // If the next key doesn't exist or isn't an object, abort the modification
    if (typeof currentObject[key] !== 'object' || currentObject[key] === null) {
      return false;
    }

    // Move to the next level in the object
    currentObject = currentObject[key];
  }
}

type SearchTree = { [key: string]: SearchTree | string[] };

export function getOptionsFromTree(
  values: object,
  optionsTree?: SearchTree,
  optionsTreePath?: string[][],
  // For a given path, if the key is not found, use this key as the default to continue searching
  defaultKey: string = '*'
): string[] | undefined {
  if (!optionsTree || !optionsTreePath) {
    return undefined;
  }

  let currentTree: SearchTree | string[] = optionsTree;

  for (const path of optionsTreePath) {
    // Resolve the key from the values object
    const key = path.reduce(
      (acc: any, current: string) => acc?.[current],
      values
    );

    const coercedKey = typeof key === 'boolean' ? String(key) : key;

    if (typeof coercedKey !== 'string') {
      return undefined; // Ensure the key is a string after coercion
    }
    // Traverse the optionsTree
    if (typeof currentTree === 'object' && currentTree[coercedKey]) {
      currentTree = currentTree[coercedKey];
    } else if (typeof currentTree === 'object' && currentTree[defaultKey]) {
      currentTree = currentTree[defaultKey];
    } else {
      return undefined; // If the key doesn't exist in the optionsTree, return undefined
    }
  }

  // Return the result, ensuring it's a string array or undefined
  return Array.isArray(currentTree) ? currentTree : undefined;
}
